"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _ContactsPicker = _interopRequireDefault(require("../common/ContactsPicker"));

var _BundlePage = require("./BundlePage");

var _Terms = require("self-service-api/constants/Terms");

var _MarketingPlanButton = _interopRequireDefault(require("./MarketingPlanButton"));

var _AccordionTransition = _interopRequireDefault(require("UIComponents/transitions/AccordionTransition"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _HubBundleHeader = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/HubBundleHeader"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _ContactsSliderContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsSliderContainer"));

var _utils = require("pricing-pages-unified-ui/components/bundle-page/utils");

var _CovidSelectors = require("pricing-pages-unified-ui/selectors/CovidSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "MarketingHubBundle__ButtonFlex",
  componentId: "mrqupl-0"
})(["", ";"], _responsiveBreakpoints.default.phone(_templateObject()));

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "MarketingHubBundle__ButtonWrapper",
  componentId: "mrqupl-1"
})(["width:100%;"]);

var StyledAccordionTransition = (0, _styledComponents.default)(_AccordionTransition.default).withConfig({
  displayName: "MarketingHubBundle__StyledAccordionTransition",
  componentId: "mrqupl-2"
})(["overflow:visible !important;"]);

var MarketingHubBundle = function MarketingHubBundle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      products = _ref.products;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var marketingPlanSelected = state.marketingPlanSelected,
      marketingUnits = state.marketingUnits;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var isGrowthSuiteSelected = (0, _utils.isGrowthSuiteSelection)(state, merchandiseMap);
  var isCovidStarterSuitePromoEligible = !!((0, _reactRedux.useSelector)(_CovidSelectors.isCovidGrowthSuitePromoEligibleSelector) && _utils.isGrowthSuiteSelection && merchandiseMap);

  var setActiveEdition = function setActiveEdition(edition) {
    var newMerchId = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.HUB_MARKETING];

    if (marketingPlanSelected) {
      var oldProduct = products[marketingPlanSelected];

      if (oldProduct.edition === edition) {
        setState({
          marketingPlanSelected: null,
          marketingUnits: 0
        });
        return;
      }
    }

    setState({
      marketingPlanSelected: newMerchId,
      marketingUnits: 0
    });
  };

  return _react.default.createElement("div", {
    className: "m-bottom-12",
    "data-selenium-id": "marketing-hub-bundle-root",
    "data-merch-id": marketingPlanSelected,
    "data-units": marketingUnits,
    "data-units-merch-id": marketingPlanSelected && products[marketingPlanSelected].additionalUnitMerchId
  }, _react.default.createElement(_HubBundleHeader.default, {
    title: title,
    subtitle: subtitle,
    hub: _Hubs.default.HUB_MARKETING,
    gaClassName: (0, _publicPageUrls.getGAClassName)('bundle-pricing-marketingcompare')
  }), _react.default.createElement(ButtonFlex, {
    className: "m-top-6"
  }, _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_MarketingPlanButton.default, {
    edition: Editions.STARTER,
    merchandiseId: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[Editions.STARTER][_Hubs.HUB_MARKETING],
    setActiveEdition: setActiveEdition
  })), _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_MarketingPlanButton.default, {
    edition: Editions.PROFESSIONAL,
    merchandiseId: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[Editions.PROFESSIONAL][_Hubs.HUB_MARKETING],
    setActiveEdition: setActiveEdition
  })), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(_MarketingPlanButton.default, {
    edition: Editions.ENTERPRISE,
    merchandiseId: (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[Editions.ENTERPRISE][_Hubs.HUB_MARKETING],
    setActiveEdition: setActiveEdition
  }))), _react.default.createElement(StyledAccordionTransition, {
    open: !!marketingPlanSelected
  }, _react.default.createElement("div", {
    className: "m-top-10"
  }, isInMCBeta ? _react.default.createElement(_ContactsSliderContainer.default, {
    baseMerchId: marketingPlanSelected,
    onChange: function onChange(value) {
      return setState({
        marketingUnits: value
      });
    },
    additionalUnitQuantity: marketingUnits || 0,
    term: _Terms.MONTHLY,
    setActiveEdition: setActiveEdition,
    isGrowthSuite: isGrowthSuiteSelected,
    isCovidPromo: isCovidStarterSuitePromoEligible
  }) : _react.default.createElement(_ContactsPicker.default, {
    merchandiseId: marketingPlanSelected,
    additionalUnitQuantity: marketingUnits || 0,
    onChange: function onChange(value) {
      return setState({
        marketingUnits: value
      });
    },
    term: _Terms.MONTHLY,
    moreDetailsGAClassName: "bundle-pricing-startercontacts",
    setActiveEdition: setActiveEdition
  }))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(MarketingHubBundle);

exports.default = _default;
module.exports = exports.default;